import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DxPopupModule, DxDataGridModule } from "devextreme-angular";
import { ResourceCostOverride } from "../../../../../domain/models/real-cost.model";

@Component({
  selector: "app-cost-override-popup",
  standalone: true,
  imports: [CommonModule, DxPopupModule, DxDataGridModule],
  templateUrl: "./cost-override-popup.component.html",
  styleUrl: "./cost-override-popup.component.scss",
})
export class CostOverridePopupComponent {
  @Input() visible: boolean = false;
  @Input() resources: ResourceCostOverride[] = [];
  @Input() isSaving: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() saveOverrides = new EventEmitter<ResourceCostOverride[]>();

  closeBtnOpts = {
    text: "Close",
    stylingMode: "outlined",
    type: "normal",
    onClick: () => this.onClose(),
  };

  saveBtnOpts = {
    text: "Save",
    stylingMode: "contained",
    type: "default",
    onClick: () => this.onSave(),
  };

  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onSave(): void {
    this.saveOverrides.emit([...this.resources]);
  }

  onHidden(): void {
    this.visibleChange.emit(false);
  }
}
